<template>
  <div class="production_wrap">
    <PCNavbar selectIndex="4"/>
    <MobileNavBar :currentActive="3" />
    <!-- <img class="top-bg bannerImgcss0" src="../../assets/img3/yewubankuai1/xiandaiwuliu-title-bg.png" alt="" /> -->
    <img class="top-bg bannerImgcss0" src="../../assets/8.4/truckImg.png" alt="" />
    <!-- 主体部分 -->
    <div class="main-container"> 
      <!-- Tab导航 -->
      <div class="tab-container">
        <!-- <div 
          v-for="tab in panels" 
          :key="tab.id"
          class="tab-item"
          :class="{active: activeTab === tab.explains}"
           @click="switchTab(tab.explains)"
        >
          <div class="tab-bg">
            {{ tab.explains }}
          </div>
        </div> -->
 
      </div>

      <!-- 内容区域 -->
       <div class="mainbody menus"  v-scroll-animate="'slide-itemgk'" style="width: 90vw; margin: 0 auto;">
          <a href="/home"><i class="el-icon-s-home"></i></a> / <a @click="goZhongoubanlie">中欧班列</a>  
          <!-- <span class="fontsizeCssy">字体 【 <em @click="fontsize='big'">大</em> <em @click="fontsize='default'">中</em> <em @click="fontsize='small'">小</em> 】</span> -->
        </div>

      <div class="content-container pianquDetail2Div">
        <el-row>
         <el-col :span="14" :xs="24">
            <h2 class="EnH2-pianqu2Detail"> 
              {{ namesenglish }}
            </h2>
            <h2 class="ChH2-pianqu2Detail"> 
                郑州国际陆港({{ names }})
            </h2>
            <div v-html="contentMsg" class="pianqu2DetailHtml">
             </div>
         </el-col>

          <el-col :span="10" :xs="24">
            
            <div v-for="(item,index) in photo.split('|')" :key="index">
              <img :src="urlBase+item" />
            </div>
            
         </el-col>
        </el-row>
      </div>
  </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'

import API from '@/api/bsInfo'

export default {
  data() {
    return {
      urlBase: process.env.VUE_APP_BASE_API,
      activeTab: '',
      activeTabid:null,
      panels:[],
      namesenglish:'',
      names:'',
      contentMsg:'',
      photo:'',
    }
  },
  components: {
    PCNavbar,
    MobileNavBar,
   
  },
  mounted() {
    this.activeTab = decodeURIComponent(this.$route.query.title || '')
    // this.activeTabid = decodeURIComponent(this.$route.query.id || '')
    console.log('接收到的标题:', this.$route.query.title)
     this.contentMsg = decodeURIComponent(this.$route.query.contentMSg || '')
   

     this.namesenglish = decodeURIComponent(this.$route.query.namesenglish || '')
     this.names = decodeURIComponent(this.$route.query.names || '')
     this.photo = decodeURIComponent(this.$route.query.photo || '')
     
     
    
   
    // this.getList();
    // this.switchTab(this.activeTab)
    
  },
  methods: {
    goZhongoubanlie(){
       const encodedTitle = encodeURIComponent('中欧班列')
        this.$router.push({
          path: '/businessDetail',
          query: {                     
            title: encodedTitle
          }
        })
    },
        //获取业务板块首页内容
async getList() {
  try {
    let objParams={
      catId:'9e6274e05d4e40438c4a357704e3c56d'
    }
    const res = await API.getBusiness(objParams)
    this.panels = res.data.businessList
    console.log('获取成功', res.data.resultData)
  } catch (error) {
    console.error('获取失败', error)
  }
},
   
    switchTab(name) {
      this.activeTab = name
      //  const encodedTitle = encodeURIComponent(name)
      //  this.$router.push({
      //   path: '/businessDetail',
      //   query: {                     
      //     title: encodedTitle
      //   }
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.production_wrap {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;

  .main-container {
    flex: 1;
    position: relative;
    // padding-bottom: 60px;

    .top-bg img {
      width:100%;
  margin-top:100px;
  height:auto;
    }
  }
}


.tab-container {
  width: 90%;
  margin:0 auto;
  margin-top:-1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  padding: 0;
  background: linear-gradient(to bottom, #f8fafe, #e3f2fd);

  .tab-item {
    flex: 1 1 180px;
    min-width: 150px;
    height: 60px;
    transition: all 0.3s ease;
    cursor: pointer;

    .tab-bg {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding: 0 20px;
      // border-radius: 8px;
      background: rgba(255,255,255,0.95);
      font-size:1.1rem;
      color: #015293;
      box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
      transition: all 0.3s ease;
    }

    &.active {
      transform: translateY(-3px);
      .tab-bg {
        background:#015293;
        // background: linear-gradient(to right, rgb(220, 241, 248),#058ad6);

        color: white;
        box-shadow: 0 4px 15px rgba(3, 210, 197, 0.3);
      }
    }

    @media (max-width: 992px) {
      flex-basis: calc(33.33% - 10px);
      min-width: 120px;
      height: 50px;
      .tab {
        font-size: 14px;
        padding: 0 15px;
      }
    }

    @media (max-width: 768px) {
      flex-basis: calc(50% - 10px);
      height: 45px;
      .tab-bg {
        font-size: 13px;
        white-space: normal;
        line-height: 1.3;
      }
    }
  }
}


.content-container {
  position: relative;
  min-height: 60vh;
  padding: 30px 0;
  padding-bottom: 0;
  // margin-bottom: 20px;

  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
   
    opacity: 0.1; 
    z-index: 0;
  }

  // 内容容器
  .article-wrapper {
    width: 90vw;
    margin:0 auto;
    position: relative;
    z-index: 1;
    display: flex;
    gap: 40px;
    border-radius: 12px;
   
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    padding: 30px;
    margin-bottom: 20px;

    .article-content {
      flex: 1;
      all: unset;
      font-size: 1rem !important;
      line-height: 2.5rem !important;
      // letter-spacing: 0.1rem;
      color: #333;

      ::v-deep *{
        margin-bottom: 1em;
        font-size: 1em !important;
        text-align: justify;
      }
    }

    .article-image {
     width: 15rem;
      height: 500px;
      // object-fit: cover;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 1200px) {
      flex-direction: column;
      padding: 25px;
      .article-image {
        width: 100%;
        height: 320px;
      }
    }

    @media (max-width: 768px) {
      padding: 20px;
      .article-image {
        height: 250px;
      }
      .article-content {
        font-size: 15px;
      }
    }
  }

  // 响应式调整
  @media (max-width: 992px) {
    padding: 25px 4%;
    &::before {
      background-attachment: scroll;
    }
  }

  @media (max-width: 768px) {
    padding: 20px 3%;
    min-height: 50vh;
  }
}

/* 页脚样式优化 */
.pc-footer, .mobile-footer {
  position: relative;
  z-index: 2;
}

.pc-footer {
  display: block;
  @media (max-width: 768px) {
    display: none !important;
  }
}

.mobile-footer {
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
}


@media (max-width: 768px) {
  .main-container {
    // padding-bottom: 40px;
  }
}

@media (max-width: 480px) {
  .tab-container {
    padding: 15px 4%;
    .tab-item {
      flex-basis: 100%;
      height: 42px;
      .tab-bg {
        font-size: 14px;
        padding: 0 10px;
      }
    }
  }
  
  .content-container .article-wrapper {
    padding: 15px;
    .article-image {
      height: 200px;
    }
  }
}
 
</style>